/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteReplacementFromBehaviorBIPInfo$Params {
  Behavior_BIPInfo_ReplacementID?: number;
}

export function DeleteReplacementFromBehaviorBIPInfo(http: HttpClient, rootUrl: string, params?: DeleteReplacementFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DeleteReplacementFromBehaviorBIPInfo.PATH, 'post');
  if (params) {
    rb.query('Behavior_BIPInfo_ReplacementID', params.Behavior_BIPInfo_ReplacementID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DeleteReplacementFromBehaviorBIPInfo.PATH = '/api/Staff/DeleteReplacementFromBehaviorBIPInfo';
